import React,{useState} from 'react';

/** Quiet, shared author treatment; comment ownership/actions stay in each adapter. */
export default function CommentAuthor({name,picture,children}:{name:string;picture?:string|null;children?:React.ReactNode}){
 const [failed,setFailed]=useState<string>();
 const usable=!!picture&&failed!==picture&&picture.length<=200000&&(/^(https:\/\/)/.test(picture)||/^data:image\/(jpeg|png|webp);base64,[A-Za-z0-9+/=]+$/.test(picture));
 const initials=name.trim().split(/\s+/).filter(Boolean).slice(0,2).map(part=>Array.from(part)[0]).join('').toLocaleUpperCase()||'?';
 return <div className="flex items-center gap-2.5 min-w-0 text-xs text-stone-500">
  <span aria-hidden="true" className="h-7 w-7 shrink-0 rounded-full overflow-hidden bg-stone-100 ring-1 ring-black/5 flex items-center justify-center text-[10px] font-medium text-stone-600">
   {usable?<img src={picture!} alt="" loading="lazy" decoding="async" referrerPolicy="no-referrer" className="h-full w-full object-cover" onError={()=>setFailed(picture!)}/>:initials}
  </span>
  <div className="min-w-0 flex-1 flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1"><span className="font-medium text-stone-700 break-words min-w-0">{name}</span>{children}</div>
 </div>;
}
